/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash f0be309c578374f727d008aece3e66d6 */

import { ConcreteRequest } from "relay-runtime";

import {  } from "relay-runtime";
export type LikesRefetchQueryVariables = {
    createdAfter: string;
    eventsLimit: number;
    fetchNewEvents: boolean;
    fetchNotifications: boolean;
    notificationItemsLimit: number;
    userId: string;
};
export type LikesRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Likes_viewer">;
    };
};
export type LikesRefetchQuery = {
    readonly response: LikesRefetchQueryResponse;
    readonly variables: LikesRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createdAfter"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "eventsLimit"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fetchNewEvents"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fetchNotifications"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationItemsLimit"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        } as any
    ], v1 = {
        "kind": "Variable",
        "name": "createdAfter",
        "variableName": "createdAfter"
    } as any, v2 = {
        "kind": "Variable",
        "name": "eventsLimit",
        "variableName": "eventsLimit"
    } as any, v3 = {
        "kind": "Variable",
        "name": "notificationItemsLimit",
        "variableName": "notificationItemsLimit"
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v5 = [
        {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceId",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "LikesRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v1 /*: any*/),
                                (v2 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "fetchNewEvents",
                                    "variableName": "fetchNewEvents"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "fetchNotifications",
                                    "variableName": "fetchNotifications"
                                },
                                (v3 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "Likes_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "LikesRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "condition": "fetchNewEvents",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "FavoriteNotifications",
                                    "kind": "LinkedField",
                                    "name": "favoriteNotifications",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": [
                                                (v1 /*: any*/),
                                                (v2 /*: any*/)
                                            ],
                                            "kind": "ScalarField",
                                            "name": "hasNewEvents",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "condition": "fetchNotifications",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favoriteNotificationsTiles",
                                    "args": (v5 /*: any*/),
                                    "concreteType": "FavoriteNotifications",
                                    "kind": "LinkedField",
                                    "name": "favoriteNotifications",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "tiles",
                                            "args": [
                                                (v1 /*: any*/),
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "Variable",
                                                    "name": "notificationsLimit",
                                                    "variableName": "eventsLimit"
                                                }
                                            ],
                                            "concreteType": "FavoriteNotification",
                                            "kind": "LinkedField",
                                            "name": "notificationsList",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "type",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "eventType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "createdDate",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "lastViewedDate",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "followingType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "page",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "totalResults",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": true,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "pdpURL",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "size",
                                                                    "value": "thumb"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "firstPhotoWebPath",
                                                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                                                        },
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "name",
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/LikesRefetchQuery",
            "metadata": {},
            "name": "LikesRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'ab2f3c4d7c41daccff0f4fa979704e09';
export default node;
